import type { ErrorComponentProps } from '@tanstack/react-router';

import { AppErrorScreen } from './AppErrorScreen';

export function AppRouterErrorScreen(input: ErrorComponentProps) {
  return <AppErrorScreen error={input.error} reset={input.reset} />;
}
